import {createAction, handleActions} from 'redux-actions';
import {ThunkAction} from 'redux-thunk';
import {RootState} from '../store';

const SET_LINK= '/SET_LINK';

export const globalLinkCreator = createAction(SET_LINK);

export function setGlobalLink(data: any): ThunkAction<void, RootState, null, ReturnType<typeof globalLinkCreator>> {
    return async function (dispatch) {
    try {
      dispatch(globalLinkCreator({
        data: data
      }));
    } catch (error) {
      
    }
  };
}

export interface CompanyInfoState {
  "config_link_naver_blog": string,
  "config_link_instgram": string,
  "config_link_kakao_talk": string,
  "config_link_kakao_channel": string,
  "config_link_youtube": string,
  "config_link_facebook": string,
  "config_link_call_number": string,
}

const initialState: CompanyInfoState = {
  "config_link_naver_blog": "",
  "config_link_instgram": "",
  "config_link_kakao_talk": "",
  "config_link_kakao_channel": "",
  "config_link_youtube": "",
  "config_link_facebook": "",
  "config_link_call_number": ""
}

export const globalLink = handleActions<CompanyInfoState, any>({
  [SET_LINK]: (state, action: ReturnType<typeof globalLinkCreator>) => ({
    config_link_naver_blog: action.payload.data.config_link_naver_blog ?? state.config_link_naver_blog,
    config_link_instgram: action.payload.data.config_link_instgram ?? state.config_link_instgram,
    config_link_kakao_talk: action.payload.data.config_link_kakao_talk ?? state.config_link_kakao_talk,
    config_link_kakao_channel: action.payload.data.config_link_kakao_channel ?? state.config_link_kakao_channel,
    config_link_youtube: action.payload.data.config_link_youtube ?? state.config_link_youtube,
    config_link_facebook: action.payload.data.config_link_facebook ?? state.config_link_facebook,
    config_link_call_number: action.payload.data.config_link_call_number ?? state.config_link_call_number,
  }),
}, initialState);
